export class MinCheckedLimitError extends Error {}

export class MaxCheckedLimitError extends Error {}

export class NegativeValueError extends Error {}

export class NumberParsingError extends Error {}
